import { useMediaQuery } from 'react-responsive';

import { INTERACT_MEDIA_BREAKPOINTS } from 'Utils/constants';

export default (sizes: (keyof typeof INTERACT_MEDIA_BREAKPOINTS)[]) =>
  sizes.map(size =>
    useMediaQuery({
      maxWidth: INTERACT_MEDIA_BREAKPOINTS[size],
    }),
  );
